<div class="relative flex w-[480px] flex-col items-center gap-4 rounded-[20px] bg-background-white p-6">
  <section class="flex flex-col gap-5 text-center">
    <h4 class="typo-h4-medium">
      {{ 'perio_exam_edit_exam_confimation_dialog_title' | translate }}
    </h4>

    <h5 class="typo-h5-book whitespace-pre-line text-text-secondary">
      {{ 'perio_exam_edit_exam_confimation_dialog_content' | translate }}
    </h5>
  </section>

  <section class="mt-4 flex w-full gap-4">
    <button class="btn-secondary-small flex-1 justify-center" (click)="onCancelClick()">
      {{ 'perio_exam_edit_exam_confimation_cancel_button' | translate }}
    </button>
    <button class="btn-primary flex-1 justify-center whitespace-pre" (click)="onFinishAndEditClick()">
      {{ 'perio_exam_edit_exam_confimation_finish_and_edit_button' | translate }}
    </button>
  </section>
</div>
